import script from "./MonitorProjectView.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitorProjectView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__